import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_general_modal = _resolveComponent("v-general-modal")!

  return (_ctx.modal.show)
    ? (_openBlock(), _createBlock(_component_v_general_modal, { key: 0 }))
    : _createCommentVNode("", true)
}